document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.nav-tabs_tab');
    const contents = document.querySelectorAll('.nav-tabs_content');

    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            const idx = tab.getAttribute('data-index');

            tabs.forEach(t => t.classList.remove('active'));
            contents.forEach(c => c.classList.remove('active'));

            tab.classList.add('active');
            const activeContent = document.querySelector('.nav-tabs_content[data-index="' + idx + '"]');
            if (activeContent) {
                activeContent.classList.add('active');
            }
        });
    });
});